function toSafeNumber(value) {
  const num = Number(value)
  return Number.isFinite(num) ? num : 0
}

export function hasPositiveRemaining(value) {
  return toSafeNumber(value) > 0
}

export async function refreshUserResourceState(store) {
  try {
    await store.dispatch("cloud/queryByUserIdApis")
  } catch (e) {
  }
}

export async function ensureSeatAvailable(store) {
  await refreshUserResourceState(store)
  return hasPositiveRemaining(store.state.user?.mailWorkPosition?.freePosition)
}

export async function ensureEdmAvailable(store) {
  await refreshUserResourceState(store)
  return hasPositiveRemaining(store.state.cloud?.userDataInformation?.freeEdmNum)
}

export async function ensureStorageAvailable(store, requiredSize = 1) {
  await refreshUserResourceState(store)
  return toSafeNumber(store.state.cloud?.spaceSize?.freeLocation) >= Math.max(toSafeNumber(requiredSize), 0)
}

export async function ensureAiPointsAvailable(store) {
  await refreshUserResourceState(store)
  return hasPositiveRemaining(store.state.cloud?.userDataInformation?.freeAiNum)
}

export async function ensureProductListLoaded(store) {
  const list = Array.isArray(store.state.buystorage?.allProductList)
    ? store.state.buystorage.allProductList
    : []
  if (list.length > 0) return list

  try {
    await store.dispatch("buystorage/getMailProductListApis", 1)
  } catch (e) {
  }

  return Array.isArray(store.state.buystorage?.allProductList)
    ? store.state.buystorage.allProductList
    : []
}

export function getProductBySort(store, productSort) {
  const list = Array.isArray(store.state.buystorage?.allProductList)
    ? store.state.buystorage.allProductList
    : []
  return list.find(item => Number(item?.productSort) === Number(productSort)) || null
}
